module.exports = __webpack_public_path__ + "static/media/alert.a9235182.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/alert.svg
// module id = 295
// module chunks = 0